import React from 'react';
import { Box, DeprecatedIcon, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { DATA_ICON_SIZE } from '../../Utils';
import { FormattedMessage, useIntl } from 'react-intl';

export interface SegmentRowProps {
  segmentName: string | null;
  onRowClick?: () => void;
}

export const SegmentRow: React.FC<SegmentRowProps> = ({ segmentName, onRowClick }) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="SegmentRow"
      icon={{ name: segmentName ? 'segments' : 'search', color: 'blue-base' }}
      label={{
        body: segmentName
          ? segmentName
          : intl.formatMessage({ defaultMessage: 'For current search', id: '0faTpU' }),
        bodyVariant: 'bold',
      }}
      value={<DeprecatedIcon size={DATA_ICON_SIZE} name="arrow-right" color="blue-base" />}
      tooltipContent={
        <>
          {!!segmentName && (
            <Box paddingTop={4} paddingBottom={8}>
              <Text appearance="bodySmall" color="secondary-inverse">
                <FormattedMessage defaultMessage="Segment: " id="HwncF/" />
              </Text>
              <Text appearance="bodySmall" color="inherit">
                {segmentName}
              </Text>
            </Box>
          )}
          <Box>
            <Text appearance="bodySmall" color="secondary-inverse">
              <FormattedMessage
                defaultMessage="The current results are restricted to this {segmentName, select, true {segment} other {search}}."
                id="4WUSIB"
                values={{ segmentName }}
              />
            </Text>
          </Box>
        </>
      }
      onRowClick={onRowClick}
    />
  );
};
